<!--  -->
<template>
    <div class='content'>
        <div class="contents">
            <div class="screen">
                <div class="table_num">
                    <span>{{ language['菜品'][LT] }}</span>
                    <el-input v-model="keyword" :placeholder="language['请输入内容'][LT]"></el-input>
                </div>
                <div class="times">
                    <span> {{ language['菜品类型'][LT] }}</span>
                    <el-select v-model="value" :placeholder="language['请选择'][LT]">
                        <el-option v-for="(item, index) in dishesList" :key="index" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </div>

                <div class="btns">
                    <el-button type="danger" @click="getResetting"> {{ language['重置'][LT] }}</el-button>
                    <el-button type="primary" @click="getScreen"> {{ language['筛选'][LT] }}</el-button>
                </div>
            </div>
            <div class="table">
                <el-table :empty-text="language['暂无数据'][LT]" :data="goodList" border style="width: 100%"
                    :header-cell-style="{ background: '#eee', }">
                    <el-table-column align="center" prop="id" label="ID" width="100"></el-table-column>
                    <el-table-column align="center" prop="name" :label="language['菜品类型'][LT]" width="180"></el-table-column>
                    <el-table-column align="center" prop="name" :label="language['菜品名称'][LT]"></el-table-column>
                    <el-table-column align="center" :label="language['操作'][LT]" width="300">
                        <template slot-scope="scope">
                            <el-radio-group @input="getRadioChange(scope.row)" v-model="scope.row.status">
                                <el-radio :label="0"> {{ language['售罄'][LT] }}</el-radio>
                                <el-radio :label="1"> {{ language['上架'][LT] }}</el-radio>
                            </el-radio-group>
                        </template>

                    </el-table-column>
                </el-table>
            </div>
            <div class="page">
                <el-pagination @current-change="getChange" :current-page="page" background layout="prev, pager, next"
                    :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { Input } from 'element-ui';
import language from '../../static/i18n/zh';

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dishesList: [], //菜品分类
            goodList: [], //商品列表
            value: '',
            keyword: '', //搜索内容
            total: 0, //数据总数
            allPage: 0, //总页数
            page: 1, //当前页数
            radio: 1,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 菜品分类
        getDishesType() {
            this.$post('64c0e52b39cd5').then(res => {
                if (res.code == 1) {
                    console.log('菜品分类', res)
                    this.dishesList = res.data;
                }
            })
        },
        // 商品列表
        getGoodList() {
            this.$post('64c0e62c111cc', { keyword: this.keyword, cate_id: this.value }).then(res => {
                if (res.code == 1) {
                    console.log('商品详情', res);
                    this.goodList = res.data;
                }
            })
        },
        // 切换页面
        getChange(event) {
            this.page = event;
            this.orderList = [];
            this.getGoodList();
        },
        // 筛选
        getScreen() {
            this.goodList = [];
            this.getGoodList();
        },
        // 重置
        getResetting() {
            this.keyword = '';
            this.value = '';
            this.getGoodList();
        },
        // 是指菜品状态
        getRadioChange(item) {
            console.log(item)
            this.$post('64cdd3abafc86', { goods_id: item.id, goods_msg: item.status }).then(res => {
                if (res.code == 1) {
                    console.log('设置菜品状态', res)
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getDishesType();
        this.getGoodList();
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.content {
    background: #eee;
    padding: 20px;
}

.contents {
    background: #fff;
    height: calc(100vh - 102px);
    padding: 20px 10px;
    box-sizing: border-box;
}

.screen {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.times span {
    font-size: 14px;
    display: inline-block;
    min-width: 80px;
}

.table_num {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: 40px;
}

.table_num span {
    display: inline-block;
    min-width: 80px;
    font-size: 14px;
}

.btns {
    margin-left: 40px;
}

.table {
    margin-top: 30px;
}

.page {
    text-align: center;
    margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/view/dishList.vue